import React from 'react';
import { Layout } from 'fronton-react';  
import { RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  FeaturesSection,
  GallerySection,
  HeaderSection,
  ProjectDevelopmentSection,
  ProjectServicesTypesSection,
  STEPS_LIST,
  StepsSection,
} from '../components';
import {
  DEFAULT_CONSULTATION_SECTION_TITLE,
  DEFAULT_CONSULTATION_SUB_CHANNEL,
} from '../engineering-systems-constants';
import { EngineeringSystemTypeProps } from '../engineering-systems-types';
import { VENTILATION_GALLERY_LIST } from './components/gallery-section';
import { VENTILATION_HEADER_SECTION_CONFIG } from './components/header-section';
import { VENTILATION_DEVELOPMENT, VENTILATION_PROJECT_TYPE_LIST } from './components/project-types-section';
import {
  VENTILATION_ELEMENT_BLOCK,
  VENTILATION_SYSTEMS_CONSULTATION_TYPE,
  VENTILATION_SYSTEMS_PATH,
} from './ventilation-systems-constants';

/**
 * Вью страницы "Системы вентиляции"
 */
export const VentilationSystems = ({
  consultationSectionRef,
  onConsultationSignupBtnClick,
  serviceTypePrice,
}: EngineeringSystemTypeProps) => (
  <RootLayout currentPage={VENTILATION_SYSTEMS_PATH}>
    <Layout>
      <HeaderSection
        headerConfig={VENTILATION_HEADER_SECTION_CONFIG}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <FeaturesSection />
      <PromoBlock elementBlock={VENTILATION_ELEMENT_BLOCK} />
      <SpecialOffer
        onModalBtnClick={onConsultationSignupBtnClick}
        elementBlock={VENTILATION_ELEMENT_BLOCK}
      />
      {serviceTypePrice && Object.keys(serviceTypePrice).length > 1 ? (
        <ProjectServicesTypesSection
          elementBlock={VENTILATION_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectTypeList={VENTILATION_PROJECT_TYPE_LIST}
          serviceTypePrice={serviceTypePrice}
        />
      ) : (
        <ProjectDevelopmentSection
          elementBlock={VENTILATION_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectDevelopmentInfo={VENTILATION_DEVELOPMENT}
          serviceTypePrice={serviceTypePrice}
        />
      )}
      <StepsSection stepSectionList={STEPS_LIST} />
      <GallerySection
        elementBlock={VENTILATION_ELEMENT_BLOCK}
        galleryList={VENTILATION_GALLERY_LIST}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <ConsultationSection
        consultationType={VENTILATION_SYSTEMS_CONSULTATION_TYPE}
        elementBlock={VENTILATION_ELEMENT_BLOCK}
        elementText="Заявка на консультацию"
        sectionRef={consultationSectionRef}
        sectionTitle={DEFAULT_CONSULTATION_SECTION_TITLE}
        subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
      />
    </Layout>
  </RootLayout>
);
